
/**
@ngdoc directive
@name loadingSpinner

@description
Adds the loading spinner for the link (the default is before the link).<br />
TODO: spinner should probably be hidden on all other links click<br />
TODO: positioning of the spinner (if only required?)

@usage
    <a href="some url" loading-spinner>your link</a>

*/

(function() {
    'use strict';

function loadingSpinner($rootScope, $document) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {

            var justClicked = false;
            var showSpinner= function(){
                justClicked = true;
                element.prev().show();
                $rootScope.$emit('loading-spinner-click');
                element.unbind('click', showSpinner);
            }
            var hideSpinner = function(e){
                if(e.keyCode == 27){ // on ESC
                    justClicked = false;
                    element.prev().hide();
                    element.bind('click', showSpinner);
                }
            }

            $rootScope.$on('loading-spinner-click', function(){
                if(!justClicked){ // otherwise it would run on click
                    element.prev().hide();
                    element.bind('click', showSpinner);
                } else {
                    justClicked = false;
                }
            });

            element.bind('click', showSpinner);

            $document.bind('keydown', hideSpinner);

            element.before( '<span style="display:none;" class="loading-spinner link-spinner" role="alert" aria-live="assertive"><span class="sr-only">Loading...</span></span>' );

            element.on('$destroy', function(){
                $document.unbind('keydown', hideSpinner);
            });
        }
    };
}
loadingSpinner.$inject = ['$rootScope', '$document'];
angular.module('app').directive('loadingSpinner', loadingSpinner);

}());
